/* eslint-disable camelcase, @typescript-eslint/naming-convention, react/require-default-props */
import React from 'react';
import classNames from 'classnames';
import { AIAgentMessageProvider } from './context';
import { getBlockRenderer } from './renderers';
import { BlockErrorBoundary } from './BlockErrorBoundary';
import { BlockWrapper } from '../AIMessageBlock/BlockWrapper';
import './AIAgentMessageStyles.scss';
const baseClass = 'qmb-ui-ai-agent-message';
/**
 * AIAgentMessage Organism
 * Orchestrates rendering of a complete agent response using a block registry pattern.
 * Each content block is rendered by a registered BlockRenderer component.
 * Unregistered block types are silently skipped.
 *
 * @version 1.0.0
 * @since 2026-02-18
 */
export function AIAgentMessage({ envelope, onConfirm, onCancel, onAction, onUndo, className, frozen = false }) {
    const { agent } = envelope;
    return (React.createElement(AIAgentMessageProvider, { agent: agent, envelope: envelope, onConfirm: onConfirm, onCancel: onCancel, onAction: onAction, onUndo: onUndo, frozen: frozen },
        React.createElement("div", { className: classNames(baseClass, className) },
            envelope.blocks.map((block, index) => {
                const Renderer = getBlockRenderer(block.type);
                if (!Renderer)
                    return null;
                return (React.createElement(BlockWrapper, { key: block.block_id || index, block: block },
                    React.createElement(BlockErrorBoundary, { blockType: block.type },
                        React.createElement(Renderer, { block: block }))));
            }),
            envelope.cancelled && (React.createElement("div", { className: `${baseClass}__cancelled-indicator` },
                React.createElement("i", { className: "fa-solid fa-stop" }),
                React.createElement("span", null, "Response stopped"))))));
}
